import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const todayKey = () => `staleCutAck:${new Date().toLocaleDateString('en-CA', { timeZone: 'America/Mexico_City' })}`;

export const StaleCutWarning = ({ cartCount }) => {
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const prev = useRef(0);

  useEffect(() => {
    const was = prev.current;
    prev.current = cartCount;
    if (was !== 0 || cartCount === 0 || localStorage.getItem(todayKey())) return;
    axios.get(`${API}/cuts/stale-check`, { withCredentials: true })
      .then(({ data }) => { if (data?.stale) setInfo(data); })
      .catch(() => {});
  }, [cartCount]);

  const lastSale = info?.last_sale_at
    ? new Date(info.last_sale_at).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' })
    : '';

  return (
    <AlertDialog open={!!info}>
      <AlertDialogContent data-testid="stale-cut-warning">
        <AlertDialogHeader>
          <AlertDialogTitle>⚠️ Corte del día anterior abierto</AlertDialogTitle>
          <AlertDialogDescription>
            La última venta de este corte fue el {lastSale} y aún no se ha cortado. ¿Deseas continuar?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="stale-cut-go-cut" onClick={() => { setInfo(null); navigate('/cuts'); }}>
            Cancelar e ir al corte
          </AlertDialogCancel>
          <AlertDialogAction data-testid="stale-cut-continue" onClick={() => { localStorage.setItem(todayKey(), '1'); setInfo(null); }}>
            Continuar
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
